import React from 'react'
import { Trans } from '@lingui/macro'
import { MIN_SEARCH_LEN } from '../constants'

type EmptyMembersSelectorProps = {
  query: string
  isAddressBookActive: boolean
}

export const EmptyMembersSelector: React.FC<EmptyMembersSelectorProps> = ({
  query,
  isAddressBookActive
}) => (
  <span className="MembersSelector__empty">
    {query.length > 0 && query.length < MIN_SEARCH_LEN ? (
      <Trans>Minimal 3 characters</Trans>
    ) : isAddressBookActive ? (
      <Trans>No more groups in your address book</Trans>
    ) : (
      <Trans>No matching users or groups found</Trans>
    )}
  </span>
)
